/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetUsersMe200ResponseContractsInner } from './get-users-me200-response-contracts-inner';

/**
 * 
 * @export
 * @interface GetUsersMe200Response
 */
export interface GetUsersMe200Response {
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'orgAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUsersMe200Response
     */
    'roles': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {Array<GetUsersMe200ResponseContractsInner>}
     * @memberof GetUsersMe200Response
     */
    'contracts': Array<GetUsersMe200ResponseContractsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'hasCardContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'hasPayContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'freeeCompanyId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUsersMe200Response
     */
    'availableFeatures': Array<GetUsersMe200ResponseAvailableFeaturesEnum>;
}

export const GetUsersMe200ResponseAvailableFeaturesEnum = {
    invoicingSystemCompliance: 'INVOICING_SYSTEM_COMPLIANCE',
    paymentRequest: 'PAYMENT_REQUEST',
    workflow: 'WORKFLOW',
    workApplication: 'WORK_APPLICATION',
    coworker: 'COWORKER',
    teamsApp: 'TEAMS_APP',
    adBoost: 'AD_BOOST',
    onlineLending: 'ONLINE_LENDING'
} as const;

export type GetUsersMe200ResponseAvailableFeaturesEnum = typeof GetUsersMe200ResponseAvailableFeaturesEnum[keyof typeof GetUsersMe200ResponseAvailableFeaturesEnum];


